import { render, staticRenderFns } from "./fortuneox.vue?vue&type=template&id=30159961&scoped=true"
import script from "./fortuneox.vue?vue&type=script&lang=js"
export * from "./fortuneox.vue?vue&type=script&lang=js"
import style0 from "./fortuneox.vue?vue&type=style&index=0&id=30159961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30159961",
  null
  
)

export default component.exports